<template>
  <div>
    <navbarBox />
    <confirmlistdatacomponents />
  </div>
</template>

<script>
import navbarBox from "../components/navbarBox";
import confirmlistdatacomponents from "@/components/confirmlistdatacomponents.vue";
export default {
  components: { confirmlistdatacomponents, navbarBox },
};
</script>
